import React, { createContext, useContext, useState } from "react";

type ProjectSummarySidebarContextType = {
  isExtended: boolean;
  toggleIsExtended: () => void;
};

const ProjectSummarySidebarContext =
  createContext<ProjectSummarySidebarContextType>({
    isExtended: false,
    toggleIsExtended: () => undefined,
  });

type ProjectSummarySidebarProviderProps = { children: React.ReactNode };

export const ProjectSummarySidebarProvider = ({
  children,
}: ProjectSummarySidebarProviderProps) => {
  const [isExtended, setIsExtended] = useState(false);
  const toggleIsExtended = () => setIsExtended((prev) => !prev);
  const context = {
    isExtended,
    toggleIsExtended,
  };
  return (
    <ProjectSummarySidebarContext.Provider value={context}>
      {children}
    </ProjectSummarySidebarContext.Provider>
  );
};

export const useProjectSummarySidebarContext = () =>
  useContext(ProjectSummarySidebarContext);
